import { AssessmentInfo } from "../assessment";
import { AssessmentScoring } from "../scoring/scoring";

export const tugInfo: AssessmentInfo = {
    shortName: "TUG",
    fullName: "Timed Up and Go",
    reportDescription: `\
<p>Der Timed Up and Go Test (TUG) ist ein standardisierter Test zur Bewertung der Mobilität und funktionellen Bewegungsfähigkeit. Er misst die Zeit, die eine Person benötigt, um von einem Stuhl aufzustehen, drei Meter zu gehen, sich umzudrehen, zurückzugehen und sich wieder hinzusetzen. Der Test liefert Informationen über das Gleichgewicht, die Gehfähigkeit und das Risiko von Stürzen. Eine kürzere Zeit zeigt eine bessere Mobilität und funktionelle Leistung an, während längere Zeiten auf Einschränkungen oder ein erhöhtes Sturzrisiko hinweisen können.</p>`
}

export const tugScoringInfo: AssessmentScoring = {
    sided: false,
    icfCategories: ["d410", "d4103", "d4104", "d4500"]
}